import { Card } from "@/components/ui/card";
import LeaderBoardCardContent from "./LeaderBoardCardContent";

export function LeaderBoardCard() {
  return (
    <Card
      id="post-form"
      className="hidden md:block p-4 md:p-5 rounded-xl shadow-lg border md:w-[94%] mx-auto lg:w-full bg-background"
    >
      <LeaderBoardCardContent />
    </Card>
  );
}
